<template>
    <div class="parking-order-detail" style=" max-height: 500px; overflow-y: auto;">
        <!-- 订单信息 -->
        <el-card class="box-card">
            <div class="info-section">
                <div class="info-title">
                    <span class="title-image"> </span>
                    <span class="title-blod">订单信息</span>
                </div>
                <el-row :gutter="20">
                    <el-col :span="8">车牌号码：{{ orderVo.plate || '- -' }}</el-col>
                    <el-col :span="8">车牌颜色：{{ orderVo.plateColorRemark || '- -' }}</el-col>
                    <!-- <el-col :span="8">订单编号：{{ orderVo.id || '- -' }}</el-col> -->
                    <el-col :span="8">入场时间：{{ orderVo.enterTime }}</el-col>
                    <el-col :span="8">离场时间：{{ orderVo.leaveTime || '- -' }}</el-col>
                    <el-col :span="8">停车时长：{{ orderVo | totalHours }}</el-col>
                    <el-col v-if="orderVo.isVideo != '' && orderVo.isVideo != null" :span="8">入场检测：{{ "1" == orderVo.isVideo  ? '巡检车' : '地磁'}}</el-col>
                </el-row>
            </div>
        </el-card>
        <!-- 停车区域 -->
        <el-card class="box-card">
            <div class="info-section">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div class="info-section1" style="width: 100%;">
                            <div class="info-title">
                                <span class="title-image"> </span>
                                <span class="title-blod">停车区域</span>
                            </div>
                            <el-row :gutter="20">
                                <el-col :span="8">车场名称：{{ orderVo.parkingName || '- -' }}</el-col>
                                <el-col :span="8">泊位编号：{{ orderVo.seatNum || '- -' }}</el-col>
                                <el-col :span="8">车辆类型：{{ orderVo.carType || '- -' }}</el-col>
                            </el-row>
                        </div>

                    </el-col>
                    <el-col :span="12">
                        <div class="info-section1" style="width: 100%;">
                            <div class="info-title">
                                <span class="title-image"> </span>
                                <span class="title-blod">用户信息</span>
                            </div>
                            <el-row :gutter="20">
                                <el-col :span="12">用户名：{{ orderVo.userName || '- -' }}</el-col>
                                <el-col :span="12">手机号：{{ orderVo.userMobile || '- -' }}</el-col>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>

            </div>
        </el-card>


        <!-- 支付信息 -->
        <el-card class="box-card">
            <div class="info-section">
                <div class="info-title">
                    <span class="title-image"> </span>
                    <span class="title-blod">支付信息</span>
                </div>
                <el-row :gutter="20" style="font-size: 16px;">
                    <el-col :span="4">累计支付：{{ orderVo.payAmount }}</el-col>
                    <el-col :span="4">支付时间：{{ orderVo.payTime || '- -' }}</el-col>
                    <el-col :span="4">收费倍数：{{ orderVo.parkingNum }}</el-col>
                    <el-col :span="4">
                        <div style="color: red;">
                            欠费金额：{{ orderVo.arrearsAmount }}
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div>
                            <span style="font-weight: 600; margin-right: 20px;">应付金额：{{ orderVo.totalMoney }}</span>

                            <el-button type="text" @click="queryOrderDetail(orderVo)">刷新</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>

        </el-card>


        <el-card class="box-card">
            <div>
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="取证图" name="images">
                        <div style="display: flex;flex-wrap: wrap;font-size: 13px;">
                            <div v-for="(item, imgKey) in imagesList" :key="imgKey"
                                style="margin-top: 10px; margin-right: 10px;">
                                <div style="width: 200px; height: 100px; overflow: hidden;">
                                    <el-image :src="item.imageUrl" :preview-src-list="[item.imageUrl]" fit="cover"
                                        style="width: 100%; height: 100%">
                                    </el-image>
                                </div>
                                <div style="display: flex; justify-content: space-between ; align-items: center;">
                                    <div>{{ item.diffTime }}分钟</div>
                                    <div>{{ item.targetTime }}</div>
                                </div>

                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="时间线" name="timeLine">
                        <el-table :data='timeLineList' max-height="300">
                            <el-table-column prop="time" label="时间"></el-table-column>
                            <el-table-column prop="userName" label="操作员"></el-table-column>
                            <el-table-column prop="remark" label="备注" width="300"></el-table-column>
                            <el-table-column prop="imgsArray" label="图片" width="300">
                                <template slot-scope="scope">
                                    <div style="display: flex; flex-wrap: wrap;">
                                        <!-- 如果 imgsArray 是 scope.row 下的一个属性 -->
                                        <div v-for="(img, imgKey) in scope.row.imgsArray" :key="imgKey"
                                            style="margin-top: 10px; margin-right: 10px;">
                                            <el-image style="width: 50px; height: 50px;" :src="img"
                                                :preview-src-list="[img]">
                                                <!-- 支持点击预览大图 -->
                                            </el-image>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="支付详情" name="pay">
                        <el-table :data='payDetailList'>
                            <el-table-column prop="payId" label="第三方支付单号"></el-table-column>
                            <el-table-column prop="payAmount" label="支付金额"></el-table-column>
                            <el-table-column prop="couponMoney" label="优惠金额"></el-table-column>
                            <el-table-column prop="payType" label="支付途径">
                                <template slot-scope="scope">
                                    {{ scope.row.payType | payType }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="payTime" label="支付时间"></el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="订单操作" name="operate">
                        <cui-orderoperat :order="order" @refresh-data="refreshData"></cui-orderoperat>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-card>
    </div>
</template>
  
<script>
export default {
    name: 'ParkingOrderDetail',
    props: {
        // 接收订单数据对象
        order: {
            type: Object,
            required: true,
            validator(value) {
                // 可选：添加简单校验
                return value && typeof value === 'object';
            }
        },
        flagCount: {
            type: Number
        }
    },
    watch: {
        flagCount(newVal) {
            // 这里可以执行一些操作，比如调用方法等。
            this.activeName = "images"
            this.getOrderDetail(this.order.id)
            this.getOrderImages(this.order.id)
        }
    },
    data() {
        return {
            activeName: "images",
            payDetailList: [],
            timeLineList: [],
            imagesList: [],
            orderVo: {},
            totalMoney: "--"
        }
    },
    created() {
        this.getOrderDetail(this.order.id)
        this.getOrderImages(this.order.id)
    },
    methods: {
        getOrderDetail(id) {
            console.log(this.orderVo)
            this.$http.get(this.$api.queryOrderDetail, { id }, (res) => {
                this.orderVo = res;
                console.log(this.orderVo)
            });
        },
        //支付详情
        detailList(id) {
            this.$http.get(this.$api.payDetailList, { id }, (res) => {
                this.payDetailList = res.list;
            });
        },
        //时间线
        getOrderDetailLine(id) {
            if (id) {
                this.$http.get(this.$api.queryOrderTimeDetail, { id }, (res) => {
                    res.list.forEach((e) => {
                        e.imgsArray = [];
                        if (e.imgs) {
                            let { bodyImgUrl, plateImgUrl, seatImgUrl } = JSON.parse(e.imgs);
                            if (bodyImgUrl) e.imgsArray.push(bodyImgUrl);
                            if (plateImgUrl) e.imgsArray.push(plateImgUrl);
                            if (seatImgUrl) e.imgsArray.push(seatImgUrl);
                        }
                    });
                    this.timeLineList = res.list
                });
            } else {
                this.$message.info("订单ID异常！");
            }
        },
        getOrderImages(id) {
            this.$http.get(this.$api.selectPatrolOrderImages, { id }, (res) => {
                res.list.forEach((e, index) => {
                    if (index == 0) {
                        e.diffTime = this.getDiffMinut(this.order.enterTime, e.targetTime)
                    } else {
                        e.diffTime = this.getDiffMinut(res.list[index - 1].targetTime, e.targetTime)
                    }
                });
                this.imagesList = res.list
            });
        },
        handleClick(tab, event) {
            if (tab.name == 'pay') {
                this.detailList(this.order.id)
            } else if (tab.name == 'timeLine') {
                this.getOrderDetailLine(this.order.id)
            } else if (tab.name == 'images') {
                this.getOrderImages(this.order.id)
            }
        },
        getDiffMinut(startTime, endTime) {
            // 转换为 Date 对象
            const start = new Date(startTime);
            const end = new Date(endTime);

            // 计算时间差（毫秒）
            const diffMs = end - start;

            // 转换为分钟（1 分钟 = 60 * 1000 毫秒）
            const diffMinutes = Math.floor(diffMs / (1000 * 60));
            return diffMinutes;
        },
        refreshData() {
            this.getOrderDetail(this.order.id)
        },
        queryOrderDetail(item) {
            this.$http.post(this.$api.selectOrderDetail, { id: item.id }, (res) => {
                this.$set(this.orderVo, "totalMoney", res.totalMoney);
            });
        },
    },

};
</script>
  
<style scoped>
.parking-order-detail {
    padding: 10px;
    font-size: 14px;
    color: #666;
}

.box-card {
    /* padding: 10px; */
    margin-bottom: 5px;
}

/deep/ .el-card__body {
    padding: 10px !important;
}

.info-section {
    /* margin-bottom: 6px; */
    /* padding-bottom: 6px; */
    /* border-bottom: 1px solid #eee; */

    /* display: flex; */
    /* justify-content: space-between; */
}

.info-section h3 {
    margin: 0 0 6px 0;
    font-size: 14px;
    font-weight: 600;
    color: #333;
}

.el-row {
    /* margin-bottom: 6px; */
    margin-top: 5px;
}

.el-col {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

.el-tag {
    margin-left: 6px;
}

.info-title {
    display: flex;
    align-items: center;
}

.title-image {
    border: 2px solid #357cff;
    height: 10px;
    font-size: 8px;
    margin-right: 5px;
}

.title-blod {
    font-size: 14px;
    font-weight: 600;
    color: black;
}
</style>